import * as React from "react";
import { useFramesEcommContext } from "../../../../../../../context/modules/EcommContent/FramesEcommContent/context/FramesEcommContext.js";
import { useFramesPriceFrom } from "../../../../../../../hooks/modules/EcommContent/FramesEcommContent/hooks/use-frames-price-from.js";
import { PriceSection } from "../../../../../../../../components/PriceSection/modules/EcommContent/components/PriceSection/PriceSection.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const FramesPriceSection = () => {
  const {
    activeVariant: { bestPrice }
  } = useProductData();
  const { displayPrice } = useFramesEcommContext();
  const { shouldDisplayFromPrice, fromPricePrefix } = useFramesPriceFrom();
  return /* @__PURE__ */ React.createElement(
    PriceSection,
    {
      originalPrice: displayPrice.originalPrice,
      orignalPriceCurrencyCode: displayPrice.currency,
      discountedPrice: displayPrice.discountedPrice,
      discountBadge: displayPrice.discountInfo?.discountBadge,
      discountDescription: displayPrice.discountInfo?.discountDescription,
      bestPrice,
      shouldDisplayFromPrice,
      fromPricePrefix
    }
  );
};
export {
  FramesPriceSection
};
//# sourceMappingURL=FramesPriceSection.js.map
